var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 87,
    viewBox: "0 0 79 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2308 8C31.4717 8 23.8868 10.3008 17.4353 14.6116C10.9839 18.9223 5.95557 25.0493 2.98628 32.2178C0.0169985 39.3863 -0.759902 47.2743 0.753826 54.8843C2.26755 62.4943 6.00392 69.4846 11.4904 74.9711C16.977 80.4576 23.9672 84.194 31.5772 85.7077C39.1873 87.2215 47.0753 86.4446 54.2438 83.4753C61.4122 80.506 67.5392 75.4777 71.85 69.0262C76.1607 62.5747 78.4616 54.9899 78.4616 47.2308C78.4498 36.8297 74.3128 26.8581 66.9581 19.5034C59.6035 12.1488 49.6318 8.01177 39.2308 8Z",
    fill: "#077D65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5851 36.2412L53.8955 36.2412C54.7734 36.2412 55.6154 36.59 56.2362 37.2108C56.8571 37.8316 57.2058 38.6736 57.2058 39.5516V53.6205C57.2058 54.4985 56.8571 55.3405 56.2362 55.9613C55.6154 56.5821 54.7734 56.9309 53.8955 56.9309H50.5851V63.5516L40.6541 56.9309H37.3437",
    stroke: "white",
    strokeWidth: 1.98621,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2757 29.6206L24.1033 29.6206C23.2254 29.6206 22.3834 29.9694 21.7625 30.5902C21.1417 31.211 20.793 32.053 20.793 32.931L20.793 46.9999C20.793 47.8779 21.1417 48.7199 21.7625 49.3407C22.3834 49.9615 23.2254 50.3103 24.1033 50.3103H27.4137V58.5861L38.9999 50.3103L47.2757 50.3103C48.1537 50.3103 48.9957 49.9615 49.6165 49.3407C50.2373 48.7199 50.5861 47.8779 50.5861 46.9999V32.931C50.5861 32.053 50.2373 31.211 49.6165 30.5902C48.9957 29.9694 48.1537 29.6206 47.2757 29.6206Z",
    stroke: "white",
    strokeWidth: 1.98621,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.97406f201d0904a9c50b9836d1bbcf27.svg";
export { ForwardRef as ReactComponent };